import { groupBy, isNil, omitBy, reduce } from 'lodash-es';
import { RADIUS, ROOFTOP_ID } from 'site-modules/shared/constants/allowed-seo-srp-request-params';

export function transformFacetsToUrlParams(facets, modifiedRadius, dealerId, deltaRadius) {
  const radius = modifiedRadius || deltaRadius;

  return omitBy(
    {
      ...reduce(
        groupBy(facets, 'type'),
        (res, filterData, type) => ({
          ...res,
          [type]: filterData.map(data => data.value),
        }),
        {}
      ),
      [ROOFTOP_ID]: dealerId,
      [RADIUS]: radius ? [radius?.toString()] : undefined,
    },
    isNil
  );
}
